const Title = ({ title, ariaLabelledById = null }) =>
	title ? (
		<h3
			id={ariaLabelledById}
			dangerouslySetInnerHTML={{ __html: title }}
			className="syndicated-footer__title"
		/>
	) : null;

export default Title;
